import { Dialog, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useContext, useEffect, useState } from "react";

import StepButtons from "src/components/buttons/StepButtons/StepButtons";
import ConfirmRightButtonModalSwitch1 from "./components/ConfirmRightButtonModalSwitch1";
import ConfirmRightButtonModalSwitch2 from "./components/ConfirmRightButtonModalSwitch2";
import MyDivider from "src/components/layout/MyDivider";
import { useNavigate } from "react-router-dom";
import { kunCustomerSendsOrder } from "src/data/keikka/handleKeikka";
import PropTypes from "prop-types";
import { useUserData } from "src/context/userContext";
import { keikka_copy } from "src/data/keikka/KeikkaFunctions";
import { KeikkaDataContext } from "src/context/KeikkaDataContext";
import { socketOnSave } from "src/data/system/socketClass";

export default function ConfirmRightButtonModal(props) {
  const { keikkaData, reloadKeikkaData } = useContext(KeikkaDataContext) || {};
  const isTarjouspyyntöChecked = props.isTarjouspyyntöChecked || false;
  const [vahvistaBetoniLaatuswitch, setVahvistaBetoniLaatuswitch] = useState(false);
  const [switch2, setSwitch2] = useState(false);
  const { user, token, socket } = useUserData();

  const navigate = useNavigate();
  const [checked3, setChecked3] = useState(false);

  useEffect(() => {
    setVahvistaBetoniLaatuswitch(!showVahvistaBetoniLaatuswitch);
  }, []);

  const dialogContentText = () => {
    const isKeikkaAdmin = keikkaData.auth.isKeikkaAdmin;
    let _action = isKeikkaAdmin ? keikkaData.tila.mainAdminAction : keikkaData.tila.mainAction;

    switch (_action) {
      case "lähetä":
        return "Vahvista tilaus ja lähetä. Tarkistamme betonipumppujen varaustilanteen sekä betonin valmistus- ja kuljetuskapasiteetin. Saat sähköpostiviestin kun tilaus hyväksytään. Voit seurata tilauksen etenemistä tässä apissa.";
      case "vastaanota":
        return "Vahvista tilaus ja siirrä tilaus käsittelyyn";
      case "hyväksy":
        return "Vahvista tilaus ja siirrä tilaus odottamaan toimitusta. Tilauksen tiedot ovat oikein ja vahvistettu.";
      case "peru":
        return "Peruuta tilaus. Tästä saattaa seurata peruutusmaksu.";
      case "uudestaan":
        return "Kopioi tilaus uudeksi tilaukseksi samoilla tiedoilla.";
      default:
        return "No action found, should not be here!";
    }
  };
  const dialogTitleText = () => {
    const isKeikkaAdmin = keikkaData.auth.isKeikkaAdmin;
    let _action = isKeikkaAdmin ? keikkaData.tila.mainAdminAction : keikkaData.tila.mainAction;
    switch (_action) {
      case "lähetä":
        return "Vahvista tilaus ja lähetä";
      case "vastaanota":
        return "Vastaanota tilaus";
      case "hyväksy":
        return "Hyväksy tilaus";
      case "peru":
        return "Peruuta tilaus.";
      case "uudestaan":
        return "Kopioi tilaus.";
      default:
        return "No action found, do what?!";
    }
  };
  const handleClose = () => props.closeModal();
  const handleCancelKlik = () => props.closeModal();

  const handleAcceptKlik = async (keikkaData, ilmoituksetHenkilölleKunTapahtuuJotain = false) => {
    const isKeikkaAdmin = keikkaData.auth.isKeikkaAdmin;
    const personId = user.personId;
    const _action = isKeikkaAdmin ? keikkaData.tila.mainAdminAction : keikkaData.tila.mainAction;

    if (keikkaData.tila.keikkaTilaId === -1) keikkaData.tila.keikkaTilaId = 0;

    switch (_action) {
      case "lähetä": {
        // kesken, vahvista tilaus
        // käyttäjä lähettää vahvistuspyynnön ja keikkatila : kesken0 -> odottaa2
        // isKeikkaAdamin, keikkaTila: kesken -> käsittelyssä3
        await kunCustomerSendsOrder(
          keikkaData,
          personId,
          token,
          isTarjouspyyntöChecked,
          ilmoituksetHenkilölleKunTapahtuuJotain,
          socket
        );
        reloadKeikkaData();
        break;
      }

      case "vastaanota": {
        if (isKeikkaAdmin) {
          keikkaData.tila.keikkaTilaId = switch2 ? 4 : 3;
        } else {
          keikkaData.tila.keikkaTilaId = 1;
        }
        await keikkaData.tila.saveKeikkaTilaToDB(
          personId,
          token,
          true,
          socket,
          keikkaData.varmenne
        );

        reloadKeikkaData();
        break;
      }
      case "hyväksy": {
        // tilaus käsittelyssä
        if (isKeikkaAdmin) {
          {
            keikkaData.tila.keikkaTilaId = 4;
            await keikkaData.tila.saveKeikkaTilaToDB(
              personId,
              token,
              true,
              socket,
              keikkaData.varmenne
            );
          }
        } else {
          await keikkaData.tila.setErrorTila(token, true, socket);
        }
        break;
      }
      case "peru": // vahvistettu, odottaa toimitusta
        keikkaData.tila.keikkaTilaId = 8;
        await keikkaData.tila.saveKeikkaTilaToDB(
          personId,
          token,
          true,
          socket,
          keikkaData.varmenne
        );
        break;
      case "kopioi": // toimitus meneillään
        //text "Kopioi tilaus uuden tilauksen pohjaksi";
        await copyKeikka(keikkaData.keikkaId, personId, token, socket);
        break;
      default:
        //text "No keikkaTilaId found";
        break;
    }
    const s = new socketOnSave(
      personId,
      socket,
      keikkaData.ownerAsiakasId,
      "keikkaData",
      "save",
      keikkaData.keikkaId
    );
    s.keikkaData = keikkaData;
    s.comment = "ConfirmRightButtonModal:handleAcceptKlik";
    s.function = "ConfirmRightButtonModal:handleAcceptKlik";
    s.emitSave();
    props.closeModal();
  };
  const copyKeikka = async (keikkaId, personId, token, socket) => {
    const newKeikkaId = await keikka_copy(keikkaId, personId, token, socket);
    navigate("/tilaus/" + newKeikkaId);
  };
  function handleSwitch1(checked) {
    setVahvistaBetoniLaatuswitch(checked);
  }
  function handleSwitch2(checked) {
    setSwitch2(checked);
  }
  const showVahvistaBetoniLaatuswitch =
    !isTarjouspyyntöChecked && keikkaData.tila.keikkaTilaId < 2 && !keikkaData.auth.isKeikkaAdmin;
  const showSwitch2 = keikkaData.tila.keikkaTilaId == 2 && keikkaData.auth.isKeikkaAdmin;

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{dialogTitleText()}</DialogTitle>
        <DialogContent>
          <MyDivider gutterBottom />
          <DialogContentText id="alert-dialog-description">{dialogContentText()}</DialogContentText>
          {showVahvistaBetoniLaatuswitch && (
            <>
              <MyDivider gutter />
              <ConfirmRightButtonModalSwitch1
                onChange={(checked) => handleSwitch1(checked)}
                onChange3={(checked) => setChecked3(checked)}
              />
            </>
          )}
          {showSwitch2 && (
            <>
              <MyDivider gutter />
              <ConfirmRightButtonModalSwitch2
                onChange={(checked) => {
                  handleSwitch2(checked);
                }}
              />
            </>
          )}
        </DialogContent>
        <StepButtons
          withPadding
          onCancelKlik={() => handleCancelKlik()}
          onAcceptKlik={() => handleAcceptKlik(keikkaData, checked3)}
          rightButtonText={rightButtonText()}
          rightButtonDisabled={showVahvistaBetoniLaatuswitch ? !vahvistaBetoniLaatuswitch : false}
        />
      </Dialog>
    </div>
  );

  function rightButtonText() {
    if (keikkaData.tila.keikkaTilaId == 2) {
      return "PERU TILAUS";
    }
    return keikkaData.tila.keikkaTilaId > 4 && keikkaData.tila.keikkaTilaId < 12
      ? "TILAA UUDESTAAN"
      : "LÄHETÄ";
  }
}

ConfirmRightButtonModal.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.func,
  isTarjouspyyntöChecked: PropTypes.bool,
};
